import { useState } from "react";
import { recognitionsData, talksData } from "./constants";

const RecognitionsAndTalks = () => {
  const achievements = [
    { year: 2017, content: "Recognized as an IoT thought leader by India IoT Congress" },
    { year: 2014, content: "Best paper award at ACM e-Energy" },
    { year: 2014, content: "Best paper award at ACM Buildsys" },
    { year: 2012, content: "Best paper award at IEEE COMSNETS E6" },
    { year: 2013, content: "Best paper finalist at ACM e-Energy" },
    { year: 2014, content: "IBM Fourth Patent Plateau award" },
    { year: 2013, content: "IBM Client Outstanding Technical Achievement Award" },
    { year: 2013, content: "IBM Eminence and Excellence Award" },
    { year: 2012, content: "IBM Outstanding Technical Achievement Award." },
    { year: 2011, content: "IBM Research Accomplishment Award" },
    { year: 2011, content: "IBM Client Outstanding Technical Achievement Award" },
    { year: 2010, content: "IBM Client Outstanding Technical Achievement Award" },
    { year: 2010, content: "Santa Fe Institute sustainability summer school scholarship" },
    { year: 2006, content: "First prize in the consumer electronics category of MIT Business Plan Competition" },
    { year: null, content: "MIT Media Laboratory graduate research assistantship" },
    { year: 2002, content: "Santa Fe Institute complex systems summer school scholarship" },
    { year: 1995, content: "Excellent Performer award from Syntel Software Private Limited" },
    {
      year: 1998,
      content: "Placed in the top 99th percentile in Sun Microsystems' worldwide Java Developer certification exam",
    },
    { year: 2007, content: "Technician class Ham Radio license" },
  ];
  const talks = [
    { content: "Distributed Energy Networks Panel Discussion", date: "ACM e-Energy, July 2015" },
    { content: "Keynote talk at IEEE Comsnets E6", date: "Bangalore, January 2014" },
    { content: "Smarter Energy Systems", date: "University of Waterloo, December 2013" },
    {
      content: "Real-time contingency analysis",
      date: "US-India High-performance computing workshop, Indian Institute of Science, December 2013",
    },
    { content: "nPlug: An Autonomous Peak Load Controller", date: "MIT Energy Club, June 2013" },
    { content: "Demand Management Systems", date: "University of Massachusetts, Amherst, June 2013" },
    { content: "Hidden costs of power cuts and battery backups", date: "IISc Bosch Center, May 2013" },
    {
      content: "ICT For Energy Sustainability: How Computer Science can save the World",
      date: "IEEE COMSNETS, January 2012",
    },
    { content: "Energy Management Panel Discussion", date: "IEEE Ants, December 2011" },
    { content: "An Introduction to Sustainability Issues", date: "Global Sustainability Summer School, July 2011" },
    { content: "IBM and Smart Grids", date: "IBM Regional Technical Exchange, May 2011" },
    { content: "Smart Grids for India", date: "IEEE Industry day, March 2011" },
    { content: "Smart Grids Panel Discussion", date: "IEEE Comsnets, January 2011" },
    { content: "Middleware for Cyber Physical Systems", date: "ACM Middleware, December 2010" },
    { content: "Build Your Own Linux Cell Phone", date: "O’Reilly E-Tel, January 2006" },
    { content: "Active RFID technologies", date: "IdTechEx RFID Summit, November 2005" },
  ];

  console.log(achievements);

  const CARDS_PER_PAGE = 3;

  // Active tab: "recognitions" or "talks"
  const [selectedTab, setSelectedTab] = useState("recognitions");

  // Page state for each tab
  const [recognitionsPage, setRecognitionsPage] = useState(0);
  const [talksPage, setTalksPage] = useState(0);

  // Total pages for each data set
  const recognitionsTotalPages = Math.ceil(recognitionsData.length / CARDS_PER_PAGE);
  const talksTotalPages = Math.ceil(talksData.length / CARDS_PER_PAGE);

  // Are we on recognitions or talks?
  const isRecognitions = selectedTab == "recognitions" ? achievements : talks;

  // Current page & total pages for active tab
  const currentPage = isRecognitions ? recognitionsPage : talksPage;
  const totalPages = isRecognitions ? recognitionsTotalPages : talksTotalPages;

  // Current data array
  const dataArray = isRecognitions ? recognitionsData : talksData;

  // Slice out the 3 items for this page
  const startIndex = currentPage * CARDS_PER_PAGE;
  const endIndex = startIndex + CARDS_PER_PAGE;
  const cardsToShow = dataArray.slice(startIndex, endIndex);

  // Switch tabs manually
  const switchTab = (tabName) => {
    setSelectedTab(tabName);
  };

  // Arrow states
  const canGoLeft = currentPage > 0;
  const canGoRight = currentPage < totalPages - 1;

  // Left arrow => previous page if possible
  const goPrevPage = () => {
    if (!canGoLeft) return; // no-op if disabled
    if (isRecognitions) {
      setRecognitionsPage((prev) => prev - 1);
    } else {
      setTalksPage((prev) => prev - 1);
    }
  };

  // Right arrow => next page if possible
  const goNextPage = () => {
    if (!canGoRight) return; // no-op if disabled
    if (isRecognitions) {
      setRecognitionsPage((prev) => prev + 1);
    } else {
      setTalksPage((prev) => prev + 1);
    }
  };

  return (
    <section className="w-full   min-h-[1000px] md:min-h-[1000px] bg-white" id="recognitionSpeed">
      <div className="max-w-7xl ml-4 ">
        {/* Description */}
        <p className=" md:text-center  w-[90%] text-[#454444] tracking-[1px] leading-[30px]  xl:text-center mt-4 text-justify">
          His various projects have been covered by prominent media outlets such as Boston Globe, BBC, IEEE Spectrum,
          MIT Technology Review, New Scientist, Scientific American, Slashdot and Wired and 16 Talks As A Distinguished
          Speaker.
        </p>

        {/* Tab Buttons */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8">
          <button
            className={`px-6 py-3  rounded-2xl w-[60%]  font-semibold md:w-[15%] p-5 ${
              selectedTab == "recognitions"
                ? "bg-secondary-color text-white  "
                : "border-2 border-secondary-color text-secondary-color "
            }`}
            onClick={() => switchTab("recognitions")}
          >
            RECOGNITIONS
          </button>
          <button
            className={`px-6 py-3 rounded-2xl  font-semibold  w-[60%] xl:w-[15%] md:w-[15%] p-5  ${
              selectedTab == "talks"
                ? "bg-secondary-color text-white "
                : "border-2 border-secondary-color text-secondary-color "
            }`}
            onClick={() => switchTab("talks")}
          >
            TALKS
          </button>
        </div>

        {/* Section Title */}
        <h3 className="text-yellow-500 text-xl sm:text-2xl md:ml-4  font-semibold mt-12 mb-2">
          {isRecognitions ? "List Of Recognitions" : "List Of Talks"}
        </h3>
        <hr className="border-2 ml-1 border-black w-20 mb-6 md:ml-4 rounded-sm 2xl:mx-5" />

        {/* Arrows + Cards */}
        <div className="flex items-center justify-center 2xl:mx-5">
          {/* Left Arrow (always visible, but disabled if can't go left) */}

          {/* 3 Cards */}
          <div className="grid  mb-10 ">
            {isRecognitions.map((item) => (
              <ul className="list-disc list-inside text-[#454444] text-sm md:text-base   p-1">
                <span className="text-yellow-500 mr-[10px]">★</span> {item.content}-{item.year || item.date}
              </ul>
            ))}
          </div>

          {/* Right Arrow (always visible, but disabled if can't go right) */}
        </div>
      </div>
    </section>
  );
};

export default RecognitionsAndTalks;
